/* eslint-disable import/prefer-default-export */
import React from 'react';
import moment from 'moment';

export const transactionColumns = (
  processors,
  timezone,
  actionsMenu,
) => [
    {
      title: 'Date',
      dataIndex: 'created_at',
      render: (date) => (
        <span title={date}>
          {moment(date).utc().add('hours', timezone.offset).format('DD/MM/YYYY h:mm:ss a')}
        </span>
      ),
      sorter: true,
    },
    {
      title: 'Reference',
      dataIndex: 'kitegateway_reference',
      sorter: true,
    },
    {
      title: 'Amount',
      dataIndex: 'transaction_amount',
      render: (value) => (
        <span>
          {new Intl.NumberFormat().format(value)}
        </span>
      ),
    },
    {
      title: 'Transaction Type',
      dataIndex: 'transaction_type',
      width: 180,
      sorter: true,
      search: false,
      filterMultiple: false,
      render: (value, record) => (
        <span>{record.transaction_type}</span>
      ),
    },
    {
      title: 'Currency',
      dataIndex: 'transaction_currency',
      width: 180,
      sorter: true,
      search: false,
      filterMultiple: false
    },
    {
      title: 'Status',
      dataIndex: 'transaction_status',
      sorter: true,
      filter: true,
      render: (transactionStatus) => {
        let color = 'default';
        if (transactionStatus === 'COMPLETED' || transactionStatus === 'COMPLETE') {
          color = 'success';
        } else if (transactionStatus === 'FAILED') {
          color = 'error';
        } else if (transactionStatus === 'CONFIRMING') {
          color = 'processing';
        } else if (transactionStatus === 'PENDING') {
          color = 'processing';
        } else if (transactionStatus === 'CANCELLED' || transactionStatus === 'CANCELLED') {
          color = 'warning';
        }

        return (
          <span className="ant-badge ant-badge-status ant-badge-not-a-wrapper">
            <span className={`ant-badge-status-dot ant-badge-status-${color}`} />
            <span className="ant-badge-status-text">{transactionStatus}</span>
          </span>
        );
      },
    },
    {
      title: 'Business Account',
      dataIndex: 'business_name',
      sorter: true,
    },
    {
      title: 'Acquirer',
      dataIndex: 'processor',
      width: 130,
      render: (record) => <span>{record.name}</span>,
      sorter: true,
      filterMultiple: false,
      filters: processors
        && processors.length !== 0
        ? processors.map((processor) => ({ value: processor._id, text: processor.name })) : [],
      onFilter: (value, record) => record.processor._id === value,
    },
    {
      title: 'Message',
      dataIndex: 'message',
    },
    {
      title: 'Merchant Ref',
      dataIndex: 'merchant_reference',
      sorter: true,
    },
    {
      title: 'Narration',
      dataIndex: 'narration',
      sorter: true,
    },
    {
      title: 'Actions',
      key: 'actions',
      width: 80,
      render: (_, record) => actionsMenu ? actionsMenu(record) : null,
    },
  ];

export const searchableFields = [
  'request_currency', 'wallet', 'provider',
  'narration', 'institution_name', 'kitegateway_reference',
  'merchant_reference', 'transaction_status', 'business_name',
  'processor_reference', 'transaction_id_processor_ref', 'transaction_type', 'service_type',
  'account_number', 'transaction_id_processor_ref',
];
